import type { MaskitoMask, MaskitoOptions } from '@maskito/core';
import type { ForwardedRef } from 'react';

import { useMaskito } from '@maskito/react';
import { forwardRef } from 'react';

import type { TextFieldProps } from './types/Input.types';

import { useComposedRefs } from '../../utils/composition';
import { Input } from '../Input';
import { TextFieldWrapper } from './TextFieldWrapper';

export interface MaskFieldProps extends TextFieldProps {
  mask?: MaskitoMask;
  maskitoOptions?: MaskitoOptions;
}

export const MaskField = forwardRef((props: MaskFieldProps, ref: ForwardedRef<HTMLInputElement>) => {
  const {
    className,
    inputClassName,
    onChange,
    label,
    placeholder,
    value,
    error,
    readOnly = false,
    mask,
    maskitoOptions,
    ...inputProps
  } = props;

  const maskOptions: MaskitoOptions = {
    mask: mask ?? maskitoOptions?.mask ?? [],
    ...maskitoOptions,
  };

  const maskitoRef = useMaskito({
    options: maskOptions,
  });

  const composedRef = useComposedRefs(maskitoRef, ref);

  return (
    <TextFieldWrapper className={className} error={error} label={label} readOnly={readOnly}>
      <Input
        ref={composedRef}
        className={inputClassName}
        onInput={onChange}
        placeholder={placeholder}
        value={value}
        readOnly={readOnly}
        {...inputProps}
      />
    </TextFieldWrapper>
  );
});
